export const MAX_AUTO_SAVE_RETRY = 10;
